import { useLocation, useNavigate } from "@tanstack/react-router";
import { Counter, TabGroup, type TabGroupTab } from "@synthesis/shared-ui";

import { ADMIN_CONSTRUCTOR_TAB_COUNTS } from "./admin-console.constants";

const CONSTRUCTOR_TABS: { key: string; to: string; label: string }[] = [
  { key: "services", to: "/admin", label: "Услуги" },
  { key: "roads", to: "/admin/roads", label: "Дороги" },
  { key: "documents", to: "/admin/documents", label: "Документы" },
];

const renderTabTitle = (label: string, count: number) => (
  <span className="inline-flex flex-nowrap items-center">
    <span>{label}</span>
    &nbsp;
    {count > 0 ? <Counter count={count} warningColor={false} /> : null}
  </span>
);

/** Табы «Конструктор — Услуги / Дороги / Документы»: активная вкладка по текущему роуту, счётчики из данных. */
export const ConstructorTabs = ({ servicesCount, roadsCount }: { servicesCount: number; roadsCount?: number }) => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const activeKey = (() => {
    if (pathname === "/admin") return "services";
    if (pathname.startsWith("/admin/roads")) return "roads";
    if (pathname.startsWith("/admin/documents")) return "documents";
    return "services";
  })();

  const tabs: TabGroupTab[] = CONSTRUCTOR_TABS.map((tab) => {
    const count =
      tab.key === "services"
        ? servicesCount
        : tab.key === "roads"
          ? (roadsCount ?? ADMIN_CONSTRUCTOR_TAB_COUNTS.roads)
          : ADMIN_CONSTRUCTOR_TAB_COUNTS.documents;

    return {
      key: tab.key,
      value: tab.key,
      title: renderTabTitle(tab.label, count),
    };
  });

  return (
    <TabGroup
      className="w-full min-w-0"
      tabs={tabs}
      activeKey={activeKey}
      onChange={(key) => navigate({ to: CONSTRUCTOR_TABS.find((tab) => tab.key === key)?.to ?? "/admin" })}
    />
  );
};
